import { render, staticRenderFns } from "./DeleteStageTournament.vue?vue&type=template&id=bf23b878&scoped=true"
import script from "./DeleteStageTournament.vue?vue&type=script&lang=js"
export * from "./DeleteStageTournament.vue?vue&type=script&lang=js"
import style0 from "./DeleteStageTournament.vue?vue&type=style&index=0&id=bf23b878&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf23b878",
  null
  
)

export default component.exports